// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3nhp4","error":"Textarea_error__2RoVZ","readonly":"Textarea_readonly__7B9q-","disabled":"Textarea_disabled__3j-T4"};